var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otherbox"},[_c('div',{staticClass:"bigImg"}),_c('h2',[_vm._v(_vm._s(_vm.data.title))]),_c('span',[_vm._v(_vm._s(_vm.data.publishTime))]),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }